import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NgApexchartsModule } from 'ng-apexcharts';
import { CandidateService } from 'src/app/shared/services/candidate.service';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  standalone: true,
  selector: 'app-users-stored',
  templateUrl: './users-stored.component.html',
  styleUrls: ['./users-stored.component.scss'],
  imports: [
    SharedModule, CommonModule,NgApexchartsModule
  ]
})
export class UsersStoredComponent implements OnInit {

  @Input() public usersAdmin = [
    {
      id: "1",
      username: "superadmin",
      firstName: "John",
      lastName: "Doe",
      email: "superadmin@example.com",
      role: "ROLE_SUPER_ADMIN",
      urlPicture: "https://example.com/superadmin.jpg"
    },
    {
      id: "2",
      username: "superadmin",
      firstName: "Bernard",
      lastName: "Lechoux",
      email: "superadmin2@example.com",
      role: "ROLE_ADMIN",
      urlPicture: "https://example.com/superadmin.jpg"
    },
    {
      id: "3",
      username: "superadmin",
      firstName: "Sander",
      lastName: "Samper",
      email: "superadmin3@example.com",
      role: "ROLE_ADMIN",
      urlPicture: "https://example.com/superadmin.jpg"
    },
    {
      id: "4",
      username: "superadmin",
      firstName: "Nove",
      lastName: "Peroux",
      email: "superadmin4@example.com",
      role: "ROLE_ADMIN",
      urlPicture: "https://example.com/superadmin.jpg"
    },
    {
      id: "5",
      username: "superadmin",
      firstName: "Malanche",
      lastName: "Doe",
      email: "superadmin5@example.com",
      role: "ROLE_ADMIN",
      urlPicture: "https://example.com/superadmin.jpg"
    },
  
    
  ]

 


  /**
   *
   */
  constructor() {
   
    
  }
  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }
}
